/* cl-bt.js — camada interativa do clone bellutia-de (Minimog 5 -> Horizon).
   JS vanilla proprio (regra 1 do operador): sem Swiper, sem Flickity, sem custom elements do tema.
   Modulos: gaveta do carrinho, marquee de reviews, acordeoes (Minimog collapsible + rodape),
   data de entrega estimada, galeria/variantes/pack da PDP (cl-pdp), barra fixa de compra. */
(function () {
  'use strict';
  if (window.__clBT) return;
  window.__clBT = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ------------------------------------------------------------------ gaveta */
  var SID = 'cl-cart-drawer';
  function cd() { return document.getElementById('cl-cart-drawer'); }
  function cdPanel() { var r = cd(); return r && (r.querySelector('.kaching-cart') || r.querySelector('.m-cart-drawer')); }
  function cdOpen() {
    var r = cd(), p = cdPanel(); if (!r || !p) return;
    p.classList.add('m-cart-drawer--active', 'active');
    r.setAttribute('aria-hidden', 'false');
    document.dispatchEvent(new CustomEvent('cl:cart-open'));
    document.documentElement.classList.add('cl-cd-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var inner = p.querySelector('.m-cart-drawer__inner'); if (inner) inner.style.setProperty('--translate-x', '0');
    }); });
  }
  function cdClose() {
    var r = cd(), p = cdPanel(); if (!r || !p) return;
    var inner = p.querySelector('.m-cart-drawer__inner'); if (inner) inner.style.setProperty('--translate-x', '100%');
    p.classList.remove('active');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cl-cd-lock');
    setTimeout(function () { if (r.getAttribute('aria-hidden') === 'true') p.classList.remove('m-cart-drawer--active'); }, 260);
  }
  function bubble(n) {
    /* header NATIVO do Horizon: <cart-icon> com .cart-bubble */
    $$('cart-icon').forEach(function (ci) {
      var t = ci.querySelector('.cart-bubble__text-count'); if (t) t.textContent = n > 0 ? (n < 100 ? String(n) : '') : '';
      if (typeof ci.renderCartBubble === 'function') { try { ci.renderCartBubble(n, false); } catch (e) {} }
      var b = ci.querySelector('.cart-bubble'); if (b) b.classList.toggle('visually-hidden', n === 0);
      if (t) t.classList.toggle('hidden', n === 0);
    });
  }
  function swap(html) {
    if (!html) return;
    var r = cd(); var wasOpen = r && r.getAttribute('aria-hidden') === 'false';
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cl-cart-drawer'); if (!fresh || !r) return;
    if (wasOpen) {
      fresh.setAttribute('aria-hidden', 'false');
      var p = fresh.querySelector('.kaching-cart') || fresh.querySelector('.m-cart-drawer'); if (p) p.classList.add('m-cart-drawer--active', 'active');
      var inner = fresh.querySelector('.m-cart-drawer__inner'); if (inner) inner.style.setProperty('--translate-x', '0');
    }
    r.replaceWith(fresh);
    document.dispatchEvent(new CustomEvent('cl:cart-swap'));
    bubble(parseInt(fresh.getAttribute('data-count') || '0', 10));
  }
  function refresh() {
    return fetch(ROOT + '?sections=' + SID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { swap(j[SID]); }).catch(function () {});
  }
  function busy(on) { var p = cdPanel(); if (p) p.classList.toggle('is-loading', !!on); }
  function change(key, qty) {
    busy(true);
    return fetch(ROOT + 'cart/change.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SID }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { busy(false); if (j.sections && j.sections[SID]) swap(j.sections[SID]); else refresh(); })
      .catch(function () { busy(false); refresh(); });
  }
  /* adiciona e abre a gaveta; body = FormData ou {items:[...]} */
  function cartAdd(body) {
    var json = !(body instanceof FormData);
    return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin',
      headers: json ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: json ? JSON.stringify(body) : body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { return refresh().then(function () { cdOpen(); return j; }); });
  }
  window.clCart = { open: cdOpen, close: cdClose, refresh: refresh, add: cartAdd };

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var r = cd();
    if (t.closest('[data-cl-cd-close]')) { e.preventDefault(); cdClose(); return; }
    if (r && t.classList && t.classList.contains('m-cart-drawer')) { cdClose(); return; }   /* overlay */
    var q = t.closest('[data-cl-qty]');
    if (q && r && r.contains(q)) { e.preventDefault(); change(q.getAttribute('data-key'), Math.max(0, parseInt(q.getAttribute('data-cl-qty'), 10))); return; }
    var ad = t.closest('[data-cl-addon]');
    if (ad && r && r.contains(ad)) {
      e.preventDefault();
      var body = r.querySelector('#cl-addons-' + ad.getAttribute('data-cl-addon'));
      $$('.m-cart-addon__body', r).forEach(function (b) { if (b !== body) b.classList.remove('open'); });
      if (body) body.classList.toggle('open');
      return;
    }
    if (t.closest('[data-cl-addon-close]') && r && r.contains(t)) { e.preventDefault(); $$('.m-cart-addon__body', r).forEach(function (b) { b.classList.remove('open'); }); return; }
    var sv = t.closest('[data-cl-addon-save]');
    if (sv && r && r.contains(sv)) {
      e.preventDefault();
      if (sv.getAttribute('data-cl-addon-save') === 'note') {
        var note = r.querySelector('[data-cl-note]');
        busy(true);
        fetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note ? note.value : '' }) }).then(function () { busy(false); refresh(); });
      } else {
        var inp = r.querySelector('[data-cl-coupon]'); var code = inp && inp.value.trim(); if (!code) return;
        busy(true);
        fetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code }) }).then(function () { busy(false); refresh(); });
      }
      return;
    }
    if (t.closest('[data-cl-cd-page]')) return;   /* "Warenkorb anzeigen" vai para /cart */
    /* icone do carrinho do header nativo (cart_type=page -> link /cart) abre a gaveta */
    var opener = t.closest('a[href="/cart"], a[href="' + ROOT + 'cart"], .header-actions__cart-icon, [data-cl-cart-open]');
    if (opener && !(r && r.contains(opener))) { e.preventDefault(); e.stopPropagation(); refresh().then(cdOpen); }
  }, true);
  document.addEventListener('change', function (e) {
    var i = e.target; var r = cd();
    if (i && i.matches && i.matches('[data-cl-qty-input]') && r && r.contains(i)) change(i.getAttribute('data-key'), Math.max(0, parseInt(i.value || '0', 10)));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cdClose(); });
  /* qualquer form de produto (/cart/add) -> gaveta */
  document.addEventListener('submit', function (ev) {
    var form = ev.target; if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (form.hasAttribute('data-cl-native')) return;
    ev.preventDefault(); ev.stopPropagation();
    var btn = ev.submitter || form.querySelector('[type="submit"],[name="add"]');
    if (btn) btn.classList.add('m-spinner-loading');
    cartAdd(new FormData(form)).catch(function (err) {
      var msg = form.querySelector('.m-product-form-message') || document.querySelector('[data-cl-pdp-msg]');
      if (msg) { msg.textContent = (err && (err.description || err.message)) || 'Fehler'; msg.style.display = 'block'; }
    }).then(function () { if (btn) btn.classList.remove('m-spinner-loading'); });
  }, true);

  /* ------------------------------------------------------------------ marquee (Trustoo) */
  function marquee(row) {
    if (row.__clm) return; row.__clm = true;
    var track = row.querySelector('.swiper-wrapper'); if (!track) return;
    var kids = Array.prototype.slice.call(track.children);
    kids.forEach(function (k) { var c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
    var paused = false, last = 0, acc = 0;
    var speed = 0.06; /* px/ms ~ ritmo do app (8000ms por card de 484px) */
    function half() { return track.scrollWidth / 2; }
    function step(ts) {
      if (!last) last = ts;
      var dt = Math.min(64, ts - last); last = ts;
      if (!paused && row.scrollWidth > row.clientWidth) {
        acc += dt * speed;
        if (acc >= 1) { var n = Math.floor(acc); acc -= n; row.scrollLeft += n; }
        if (row.scrollLeft >= half()) row.scrollLeft -= half();
      }
      requestAnimationFrame(step);
    }
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (ev) { row.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { row.addEventListener(ev, function () { setTimeout(function () { paused = false; }, ev === 'touchend' ? 2500 : 0); }, { passive: true }); });
    row.addEventListener('scroll', function () { if (row.scrollLeft >= half()) row.scrollLeft -= half(); }, { passive: true });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) requestAnimationFrame(step);
  }

  /* ------------------------------------------------------------------ acordeoes */
  function setCollapsible(tab, open, anim) {
    var btn = tab.querySelector('.m-collapsible--button');
    var content = tab.querySelector('.m-collapsible--content');
    if (!content) return;
    if (open) tab.setAttribute('open', 'true'); else tab.removeAttribute('open');
    tab.classList.toggle('m-collapsible--opened', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    content.setAttribute('aria-hidden', open ? 'false' : 'true');
    var inner = content.firstElementChild;
    var h = inner ? inner.scrollHeight : content.scrollHeight;
    if (!anim) { content.style.height = open ? 'auto' : '0px'; return; }
    content.style.height = (open ? 0 : content.scrollHeight) + 'px';
    requestAnimationFrame(function () {
      content.style.height = (open ? h : 0) + 'px';
      if (open) setTimeout(function () { if (tab.hasAttribute('open')) content.style.height = 'auto'; }, 300);
    });
  }
  function initCollapsibles(root) {
    $$('.m-collapsible', root).forEach(function (tab) {
      if (tab.__clc) return; tab.__clc = true;
      setCollapsible(tab, tab.getAttribute('open') === 'true' || tab.hasAttribute('open') && tab.getAttribute('open') !== 'false', false);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.m-collapsible--button');
    if (b) {
      var tab = b.closest('.m-collapsible'); if (!tab) return;
      e.preventDefault();
      setCollapsible(tab, !tab.hasAttribute('open'), true);
      return;
    }
    /* rodape mobile (m-accordion--item) */
    var fb = e.target.closest && e.target.closest('.m-accordion--item-button');
    if (fb && window.matchMedia('(max-width: 767px)').matches) {
      var item = fb.closest('.m-accordion--item'); if (!item) return;
      var c = item.querySelector('.m-accordion--item-content'); var open = !item.classList.contains('m-accordion--item-active');
      item.classList.toggle('m-accordion--item-active', open);
      if (c) { c.style.maxHeight = open ? c.scrollHeight + 'px' : '0px'; c.style.overflow = 'hidden'; c.style.transition = 'max-height .25s ease'; }
    }
  });

  /* ------------------------------------------------------------------ entrega estimada */
  function ddmm(d) { return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2); }
  function initShipping(root) {
    $$('[data-cl-eta]', root).forEach(function (el) {
      var a = parseInt(el.getAttribute('data-from') || '4', 10), b = parseInt(el.getAttribute('data-to') || '8', 10);
      var now = new Date(); var d1 = new Date(now.getTime() + a * 864e5), d2 = new Date(now.getTime() + b * 864e5);
      el.textContent = ddmm(d1) + ' - ' + ddmm(d2);
    });
  }

  /* ------------------------------------------------------------------ dinheiro (money_format da loja) */
  window.clMoney = function (cents, fmt) {
    fmt = fmt || window.clMoneyFormat || '{{amount_with_comma_separator}} €';
    cents = Math.round(Number(cents) || 0);
    function d(n, p, t, s) {
      var x = (n / 100).toFixed(p).split('.');
      var i = x[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return p ? i + s + x[1] : i;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return d(cents, 2, ',', '.');
        case 'amount_no_decimals': return d(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return d(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return d(cents, 2, "'", '.');
        default: return d(cents, 2, '.', ',');
      }
    });
  };

  /* modal que o JS dele joga no <body>: host DENTRO do wrapper escopado (cl-pdp-xx), senao perde o CSS */
  window.clModalHost = function (from) {
    var w = from && from.closest && from.closest('[class*="cl-pdp-"]');
    var cls = w ? (w.className.match(/\bcl-pdp-[a-z]+\b/) || [''])[0] : '';
    if (!cls) return document.body;
    var host = document.querySelector('body > .cl-modal-host.' + cls);
    if (!host) { host = document.createElement('div'); host.className = cls + ' cl-modal-host'; document.body.appendChild(host); }
    return host;
  };

  /* ------------------------------------------------------------------ PDP */
  function gallery(area, api) {
    var main = area.querySelector('.m-product-media--slider__images .swiper-wrapper');
    if (!main || main.__clg) return; main.__clg = true;
    var slides = Array.prototype.slice.call(main.children);
    var thumbsWrap = area.querySelector('.m-product-media--slider__thumbnails .swiper-wrapper, .nav-swiper-container .swiper-wrapper');
    var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.children) : [];
    var bullets = area.querySelector('.swiper-pagination');
    var idx = 0;
    if (bullets && !bullets.children.length && slides.length > 1) {
      slides.forEach(function (_, i) {
        var b = document.createElement('span'); b.className = 'swiper-pagination-bullet'; b.setAttribute('role', 'button');
        b.addEventListener('click', function () { go(i); }); bullets.appendChild(b);
      });
    }
    function mark(i) {
      idx = i;
      slides.forEach(function (s, k) { s.classList.toggle('swiper-slide-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('swiper-slide-thumb-active', k === i); });
      if (bullets) Array.prototype.forEach.call(bullets.children, function (b, k) { b.classList.toggle('swiper-pagination-bullet-active', k === i); });
      var t = thumbs[i];
      if (t && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        var left = t.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
        thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    function go(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      main.__prog = true;
      main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft * 0, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
      setTimeout(function () { main.__prog = false; }, 600);
    }
    main.addEventListener('scroll', function () {
      if (main.__prog) return;
      var i = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
      if (i !== idx && i >= 0 && i < slides.length) mark(i);
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function (e) { e.preventDefault(); go(i); }); t.style.cursor = 'pointer'; });
    var prev = area.querySelector('.swiper-button-prev'), next = area.querySelector('.swiper-button-next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(idx + 1); });
    mark(0);
    api.push(function (mediaId) {
      for (var k = 0; k < slides.length; k++) if (String(slides[k].getAttribute('data-media-id')) === String(mediaId)) { go(k); return; }
    });
  }

  function pdp(root) {
    if (root.__clp) return; root.__clp = true;
    var dataEl = root.querySelector('script[data-cl-product]');
    var data = {}; try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    if (data.money) window.clMoneyFormat = data.money;
    var goMedia = [];
    function initGal() { $$('.m-product-media--desktop, .m-product-media--mobile', root).forEach(function (a) { gallery(a, goMedia); }); }
    initGal(); root.__clInitGal = initGal;
    var form = root.querySelector('form.cl-pdp-form');
    var idInput = form && form.querySelector('[data-cl-variant-id]');
    function current() {
      var opts = [];
      $$('input[data-cl-opt]:checked', root).forEach(function (i) { opts[+i.getAttribute('data-cl-opt')] = i.value; });
      return (data.variants || []).find(function (v) {
        return v.options.every(function (o, k) { return opts[k] === undefined || opts[k] === o; });
      });
    }
    root.addEventListener('change', function (e) {
      var i = e.target; if (!i.matches || !i.matches('input[data-cl-opt]')) return;
      var vb = i.closest('variant-button');
      if (vb) {
        var sel = vb.querySelector('.option-label--selected'); if (sel) sel.textContent = i.value;
        vb.setAttribute('data-selected-value', i.value);
      }
      var v = current(); if (!v) return;
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      var tv = root.querySelector('[data-cl-total]'), tw = root.querySelector('[data-cl-total-was]'), ts = root.querySelector('[data-cl-total-save]');
      var cmpOk = v.compare_at_price > v.price;
      if (tv) tv.textContent = window.clMoney(v.price);
      if (tw) tw.textContent = cmpOk ? window.clMoney(v.compare_at_price) : '';
      if (ts) ts.textContent = cmpOk ? 'Risparmia il ' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %' : '';
      $$('[data-cl-atc]', root).forEach(function (b) { b.disabled = !v.available; var tx = b.querySelector('.ps-atc__text'); if (tx) tx.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito'; });
      $$('[data-cl-price]', root).forEach(function (p) {
        $$('.m-price-item--regular:not(s), .m-price-item--sale', p).forEach(function (s) { s.textContent = window.clMoney(v.price); });
        var cmp = p.querySelector('s.m-price-item--regular'); if (cmp) cmp.textContent = v.compare_at_price > v.price ? window.clMoney(v.compare_at_price) : '';
      });
      var atc = root.querySelector('.m-add-to-cart');
      if (atc) { atc.disabled = !v.available; var tx = atc.querySelector('.m-add-to-cart--text'); if (tx) tx.textContent = v.available ? (atc.getAttribute('data-atc-text') || 'Aggiungi al carrello') : 'Esaurito'; }
      initGal();
      if (+i.getAttribute('data-cl-opt') === 0 && v.featured_media && v.featured_media.id) goMedia.forEach(function (f) { f(v.featured_media.id); });
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e2) {}
    });
    /* barra fixa "Waehle dein Paket" (ig-sticky-atc): aparece quando o buybox sai da tela por cima */
    var bar = root.querySelector('[data-ig-sticky]');
    var target = root.querySelector('[data-cl-app-slot]') || root.querySelector('[data-pack-switcher]') || root.querySelector('.main-product__block-buy_buttons');
    /* ATC copiado (rodape do pack, fora do form) -> submit do form unico pelo botao de DENTRO (o app Kaching escuta esse form) */
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cl-atc]'); if (!b || b.disabled || !form) return;
      e.preventDefault();
      var sb = form.querySelector('[type="submit"],[name="add"]');
      b.classList.add('m-spinner-loading');
      var sp = b.querySelector('.ps-atc__spinner'); if (sp) sp.hidden = false;
      setTimeout(function () { b.classList.remove('m-spinner-loading'); if (sp) sp.hidden = true; }, 2500);
      if (form.requestSubmit) form.requestSubmit(sb || undefined); else if (sb) sb.click(); else form.submit();
    });
    /* total do rodape do pack = barra SELECIONADA do app (o operador escondeu o preco nas barras, como o pack dele) */
    var slotEl = root.querySelector('[data-cl-app-slot]');
    function num(s) { s = String(s || '').replace(/[^\d,.]/g, ''); if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.'); else s = s.replace(/,/g, ''); return parseFloat(s) || 0; }
    root.__clSyncTotal = function () { syncTotal(); };
    function syncTotal() {
      if (!slotEl) return;
      var bar = slotEl.querySelector('.kaching-bundles__bar--selected');
      if (!bar) { var ck = slotEl.querySelector('.kaching-bundles__bar input:checked'); bar = ck && ck.closest('.kaching-bundles__bar'); }
      var pr = bar && bar.querySelector('.kaching-bundles__bar-price'); if (!pr || !pr.textContent.trim()) return;
      var fu = bar.querySelector('.kaching-bundles__bar-full-price');
      var p = num(pr.textContent), f = fu ? num(fu.textContent) : 0;
      var q = form && form.querySelector('input[name="quantity"]'); q = q ? parseInt(q.value, 10) || 1 : 1;
      var tv = root.querySelector('[data-cl-total]'), tw = root.querySelector('[data-cl-total-was]'), ts = root.querySelector('[data-cl-total-save]'), pu = root.querySelector('[data-cl-perunit]');
      if (tv) tv.textContent = pr.textContent.trim();
      if (tw) tw.textContent = f > p ? fu.textContent.trim() : '';
      if (ts) ts.textContent = f > p ? 'Risparmia il ' + Math.round((f - p) * 100 / f) + ' %' : '';
      if (pu) { pu.hidden = q < 2; if (q > 1) pu.textContent = window.clMoney(Math.round(p * 100 / q)) + ' al pezzo'; }
    }
    if (slotEl && window.MutationObserver) {
      var pend = 0;
      new MutationObserver(function () { if (pend) return; pend = requestAnimationFrame(function () { pend = 0; syncTotal(); }); })
        .observe(slotEl, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'], characterData: true });
      if (form) form.addEventListener('change', function () { setTimeout(syncTotal, 50); });
    }
    root.addEventListener('click', function (e) {
      var g = e.target.closest && e.target.closest('[data-ps-sizeguide]'); if (!g || g.closest('[data-pack-switcher]')) return;
      e.preventDefault(); if (typeof window.openPopup === 'function') window.openPopup();
    });
    if (bar && target) {
      bar.hidden = false;
      var btn = bar.querySelector('[data-ig-sticky-btn]');
      if (btn) btn.addEventListener('click', function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) {
        var e = en[0]; bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(target);
    }
  }
  window.clPDP = function (scope) { $$('.cl-pdp[data-cl-pdp]', scope).forEach(pdp); };

  /* ------------------------------------------------------------------ videos (regra 1: tocam, inclusive no iPhone) */
  function initVideos(root) {
    $$('[class*="cl-sec-"] video, .cl-pdp video', root).forEach(function (v) {
      if (v.__clv) return; v.__clv = true;
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.loop = true;
      var play = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) play(); else v.pause(); }); }, { threshold: 0.2 }).observe(v);
      } else play();
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(root) {
    initVideos(root);
    $$('[data-cl-marquee]', root).forEach(marquee);
    initCollapsibles(root);
    initShipping(root);
    if (window.clPDP) window.clPDP(root);
  }
  window.clBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* ------------------------------------------------------------------ gaveta Kaching Cart (retrabalho 10-20)
   timer "laeuft ab in" (10 min, reinicia quando o carrinho muda), troca de variante na linha, upsell (variante +
   "In den Warenkorb"), carrossel por scroll-snap, checkout. Abre/fecha/qtd/remover ficam no modulo da gaveta acima. */
(function () {
  'use strict';
  if (window.__clKC) return; window.__clKC = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TKEY = 'cl-kc-timer', DUR = 10 * 60 * 1000;
  function drawer() { return document.getElementById('cl-cart-drawer'); }
  function sig() { var d = drawer(); return d ? d.getAttribute('data-count') + ':' + d.getAttribute('data-total') : ''; }
  function start() {
    var s = sig(), st = null;
    try { st = JSON.parse(localStorage.getItem(TKEY) || 'null'); } catch (e) {}
    if (!st || st.sig !== s) { st = { t: Date.now(), sig: s }; try { localStorage.setItem(TKEY, JSON.stringify(st)); } catch (e) {} }
    return st.t;
  }
  var t0 = null;
  function tick() {
    var els = document.querySelectorAll('#cl-cart-drawer [data-clk-timer]'); if (!els.length) return;
    if (t0 === null) t0 = start();
    var left = Math.max(0, DUR - (Date.now() - t0)), m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }
  document.addEventListener('cl:cart-swap', function () { t0 = start(); tick(); });
  document.addEventListener('cl:cart-open', tick);
  setInterval(tick, 1000); tick();

  function pick(card) {
    var j = card.querySelector('script[data-clk-variants]'); if (!j) return null;
    var vs; try { vs = JSON.parse(j.textContent); } catch (e) { return null; }
    var want = []; card.querySelectorAll('select[data-clk-opt]').forEach(function (s) { want[+s.getAttribute('data-clk-opt')] = s.value; });
    return vs.find(function (v) { return v.options.every(function (o, k) { return want[k] === undefined || want[k] === o; }); }) || null;
  }
  function busy(on) { var p = document.querySelector('#cl-cart-drawer .kaching-cart'); if (p) p.classList.toggle('is-loading', !!on); }
  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s.matches || !s.matches('#cl-cart-drawer select[data-clk-opt]')) return;
    var line = s.closest('.kaching-cart-item'), up = s.closest('[data-clk-upsell]');
    if (line) {
      var v = pick(line); if (!v) return;
      var q = line.querySelector('[data-cl-qty-input]'); q = q ? parseInt(q.value, 10) || 1 : 1;
      busy(true);
      post('cart/change.js', { id: line.getAttribute('data-key'), quantity: 0 })
        .then(function () { return post('cart/add.js', { items: [{ id: v.id, quantity: q }] }); })
        .catch(function () {}).then(function () { busy(false); return window.clCart && window.clCart.refresh(); });
    } else if (up) {
      var u = pick(up); if (!u) return;
      up.setAttribute('data-variant-id', u.id);
      var pr = up.querySelector('[data-clk-price]'); if (pr && window.clMoney) pr.textContent = '⁨' + window.clMoney(u.price) + '⁩';
      var b = up.querySelector('[data-clk-upsell-add]'); if (b) { b.disabled = !u.available; b.textContent = u.available ? 'Aggiungi al carrello' : 'Esaurito'; }
    }
  });
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var add = t.closest('#cl-cart-drawer [data-clk-upsell-add]');
    if (add) {
      e.preventDefault(); if (add.disabled) return;
      var card = add.closest('[data-clk-upsell]'), id = card && parseInt(card.getAttribute('data-variant-id'), 10);
      if (!id || !window.clCart) return;
      busy(true); add.disabled = true;
      window.clCart.add({ items: [{ id: id, quantity: 1 }] }).catch(function () {}).then(function () { busy(false); add.disabled = false; });
      return;
    }
    var nav = t.closest('#cl-cart-drawer [data-clk-car]');
    if (nav) {
      e.preventDefault();
      var list = nav.closest('.kaching-cart__carousel').querySelector('[data-clk-car-list]'); if (!list) return;
      var dir = parseInt(nav.getAttribute('data-clk-car'), 10), w = list.clientWidth, max = list.scrollWidth - w - 2;
      if (dir > 0 && list.scrollLeft >= max) list.scrollTo({ left: 0 });
      else if (dir < 0 && list.scrollLeft <= 2) list.scrollTo({ left: list.scrollWidth });
      else list.scrollBy({ left: dir * w });
      return;
    }
    if (t.closest('#cl-cart-drawer [data-clk-checkout]')) {
      e.preventDefault();
      var sp = drawer().querySelector('.kaching-cart__checkout-button-spinner'); if (sp) sp.style.display = 'inline-block';
      window.location.href = ROOT + 'checkout';
    }
  });
})();
window.clKcTotal = function (root) { if (root && root.__clSyncTotal) root.__clSyncTotal(); };

/* ------------------------------------------------------------------ pack DELE + app Kaching (retrabalho 2, 10-20)
   tiers do pack escondidas: a barra do app define quantas linhas o pack mostra; cor/tamanho gerais -> radios do
   seletor nativo escondido (foto + input id do form unico); ATC: o app monta o POST (deal, brinde) e o handler de
   fetch dele e embrulhado so para dividir a linha principal pelas variantes escolhidas nas linhas. */
(function () {
  'use strict';
  if (window.__clPackKC) return; window.__clPackKC = true;
  function pdpOf(el) { return el && el.closest && el.closest('.cl-pdp'); }
  function formOf(root) { return root && document.getElementById(root.getAttribute('data-form-id')); }
  function hasBars(root) { return !!(root && root.querySelector('[data-cl-app-slot] .kaching-bundles__bar')); }
  function barQty(root) {
    var f = formOf(root), q = f && f.querySelector('input[name="quantity"]');
    return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
  }
  function setBuy(pack, q) {
    var tiers = pack.data.tiers, idx = -1;
    for (var i = 0; i < tiers.length; i++) if (tiers[i].buy === q) { idx = i; break; }
    if (idx < 0) { tiers.push({ name: '', sub: '', buy: q, pay: q }); idx = tiers.length - 1; }
    if (idx === pack.tierIndex && pack.items.length === q) return;
    pack.tierIndex = idx; pack.syncItems(); pack.render();
  }
  function syncQty(root) {
    var pk = root && root.querySelector('[data-pack-switcher]'); pk = pk && pk.__clPack; if (!pk) return;
    setBuy(pk, hasBars(root) ? barQty(root) : 1);
  }
  function pickRadio(root, pos, val) {
    if (!val) return;
    var r = root.querySelector('[data-variant-picker] input[data-cl-opt="' + pos + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  window.clPackAfter = function (pack) {
    var root = pdpOf(pack.root); if (!root) return;
    if (pack.hasColors) pickRadio(root, 0, pack.generalColor);
    if (pack.hasSizes) pickRadio(root, pack.hasColors ? 1 : 0, pack.generalSize);
    if (hasBars(root) && window.clKcTotal) window.clKcTotal(root);
  };
  function boot() {
    document.querySelectorAll('.cl-pdp').forEach(function (root) {
      if (root.__clInitGal) root.__clInitGal();
      if (root.__clPKC) return;
      var pk = root.querySelector('[data-pack-switcher]'), slot = root.querySelector('[data-cl-app-slot]');
      if (!pk || !slot) return;
      root.__clPKC = true;
      /* modal do pack: o cl-pack.js roda antes do cl-bt.js (sem clModalHost) e o manda cru para o <body>, fora do CSS
         escopado -> host com a classe do wrapper (mesmo CSS do pack) */
      var pack0 = pk.__clPack, md = pack0 && pack0.els.modal;
      if (md && md.parentNode === document.body && window.clModalHost) window.clModalHost(pk).appendChild(md);
      var pend = 0;
      var go = function () { if (pend) return; pend = setTimeout(function () { pend = 0; syncQty(root); }, 60); };
      if (window.MutationObserver) new MutationObserver(go).observe(slot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
      var f = formOf(root); if (f) f.addEventListener('change', go);
      root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-cl-app-slot]')) setTimeout(go, 200); });
      go(); setTimeout(go, 1500); setTimeout(go, 4000);
      /* ATC: valida as linhas como o pack dele e prepara a divisao por variante */
      root.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-cl-atc]'); if (!b) return;
        var pack = pk.__clPack; if (!pack) return;
        pack.showMessage('');
        if (pack.hasSizes && pack.items.some(function (it) { return !it.size; })) {
          e.preventDefault(); e.stopImmediatePropagation(); pack.showMessage('Seleziona prima una taglia.'); return;
        }
        var ids = [], bad = false;
        pack.items.forEach(function (it) { var v = pack.variantFor(it.color, it.size); if (!v || !v.available) bad = true; else ids.push(v.id); });
        if (bad || !ids.length) {
          e.preventDefault(); e.stopImmediatePropagation();
          pack.showMessage('Seleziona un colore e una taglia disponibili per ogni articolo.'); return;
        }
        window.__clSplit = { ids: ids, at: Date.now() };
        wrapKaching();
      }, true);
    });
  }
  /* divide a linha principal do lote do app pelas variantes das linhas (gift/brinde e propriedades do deal intactos) */
  function rewrite(init) {
    var sp = window.__clSplit; window.__clSplit = null;
    if (!sp || Date.now() - sp.at > 15000 || !init || !init.body) return init;
    var body = init.body, items, extra = {};
    if (typeof body === 'string') {
      var j; try { j = JSON.parse(body); } catch (e) { return init; }
      if (Array.isArray(j.items)) { items = j.items; Object.keys(j).forEach(function (k) { if (k !== 'items') extra[k] = j[k]; }); }
      else if (j.id) { var it0 = { id: +j.id, quantity: +(j.quantity || 1), properties: j.properties || {} }; items = [it0]; }
      else return init;
    } else if (body instanceof FormData) {
      var props = {}, it = { id: +body.get('id'), quantity: +(body.get('quantity') || 1) };
      body.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props[m[1]] = v; else if (!/^(id|quantity)$/.test(k) && typeof v === 'string') extra[k] = v; });
      it.properties = props; items = [it];
    } else return init;
    var main = items.filter(function (i) { var p = (i.properties || {}).__kaching_bundles; try { return p && JSON.parse(p).main; } catch (e) { return false; } })[0]
      || items.filter(function (i) { return !i.parent_id; })[0];
    if (!main) return init;
    var cnt = {}, order = [];
    sp.ids.forEach(function (id) { if (!cnt[id]) { cnt[id] = 0; order.push(id); } cnt[id]++; });
    if (order.length === 1 && +order[0] === +main.id && cnt[order[0]] === +main.quantity) return init;
    var mains = order.map(function (id) { return { id: +id, quantity: cnt[id], properties: Object.assign({}, main.properties || {}) }; });
    var rest = items.filter(function (i) { return i !== main; }).map(function (i) {
      return i.parent_id && +i.parent_id === +main.id ? Object.assign({}, i, { parent_id: mains[0].id }) : i;
    });
    var out = Object.assign({}, extra, { items: rest.concat(mains) });
    return Object.assign({}, init, { body: JSON.stringify(out), headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } });
  }
  function wrapKaching() {
    var h = window.__kachingBundlesFetchHandler;
    if (typeof h === 'function') {
      if (h.__clSplit) return;
      var w = function (orig, url, init) {
        return h(function (u, i2) { try { i2 = rewrite(i2); } catch (e) {} return orig(u, i2); }, url, init);
      };
      w.__clSplit = true; window.__kachingBundlesFetchHandler = w;
      return;
    }
    /* sem o app (produto sem deal): o POST e o FormData do form; divide aqui */
    if (!window.fetch.__clSplit) {
      var f0 = window.fetch;
      var wf = function (u, i2) { try { if (String(u && u.url || u).indexOf('/cart/add') >= 0 && window.__clSplit) i2 = rewrite(i2); } catch (e) {} return f0.call(this, u, i2); };
      wf.__clSplit = true; window.fetch = wf;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(boot, 1500); setTimeout(boot, 4000);
})();
